// extracted by mini-css-extract-plugin
module.exports = {"button":"GetPlusButton_button___vdOg"};